import playIcon from "../../../assets/icons/play-icon.webp";
import { useRef, useState, useEffect } from "react";

const ProductQuickViewGallery = ({
  selectedMedia,
  setSelectedMedia,
  selectedColor,
  handleMouseMove,
  handleMouseLeave,
  loading,
  Skeleton,
  imageRef,
  zoomStyle,
  localLoading,
}) => {
  const thumbRef = useRef(null);
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);

  const checkScroll = () => {
    if (!thumbRef.current) return;
    const { scrollTop, scrollHeight, clientHeight } = thumbRef.current;
    setCanScrollUp(scrollTop > 0);
    setCanScrollDown(scrollTop + clientHeight < scrollHeight - 1);
  };

  useEffect(() => {
    checkScroll();
  }, [selectedColor, localLoading]);

  const scrollThumbs = (direction) => {
    if (!thumbRef.current) return;
    thumbRef.current.scrollBy({
      top: direction === "up" ? -90 : 90,
      behavior: "smooth",
    });
  };

  return (
    <div
      className="product-gallery"
      style={{ display: "flex", gap: "10px", padding: "0 20px 20px" }}
    >
      {/* ================= THUMBNAILS ================= */}
      <div style={{ width: "80px", position: "relative", textAlign: "center" }}>

        {/* UP BUTTON (hidden on loading) */}
        {!localLoading && (
          <button
            onClick={() => scrollThumbs("up")}
            disabled={!canScrollUp}
            className="thumb-arrow up"
          >
            <i className="bi bi-chevron-up"></i>
          </button>
        )}

        <div
          ref={thumbRef}
          onScroll={checkScroll}
          className="thumbnail-column"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            maxHeight: "551px",
            overflowY: "auto",
            padding: "5px 0",
            scrollbarWidth: "none",
          }}
        >
          {localLoading ? (
            Array(5)
              .fill(0)
              .map((_, i) => (
                <Skeleton key={i} height={70} width={70} borderRadius={6} />
              ))
          ) : (
            <>
              {selectedColor?.product_media?.map((img, i) => (
                <img
                  key={i}
                  src={img.media}
                  onClick={() => setSelectedMedia(img.media)}
                  className={`thumbnail ${selectedMedia === img.media ? "selected-thumb" : ""
                    }`}
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    objectFit: "cover",
                  }}
                  alt=""
                />
              ))}

              {selectedColor?.video_source && (
                <div
                  className={`thumbnail video-thumb ${selectedMedia === "video" ? "selected-thumb" : ""
                    }`}
                  onClick={() => setSelectedMedia("video")}
                  style={{ position: "relative", cursor: "pointer" }}
                >
                  <img src={playIcon} alt="Video" />
                  <div className="thumb-overlay">
                    <i className="bi bi-play-circle"></i>
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {/* DOWN BUTTON (hidden on loading) */}
        {!localLoading && (
          <button
            onClick={() => scrollThumbs("down")}
            disabled={!canScrollDown}
            className="thumb-arrow down"
            style={{ bottom: "15px" }}
          >
            <i className="bi bi-chevron-down"></i>
          </button>
        )}
      </div>

      {/* ================= MAIN IMAGE ================= */}
      <div
        className="main-image-container zoom-container"
        style={{
          flex: 1,
          height: "546px",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onMouseMove={selectedMedia !== "video" ? handleMouseMove : null}
        onMouseLeave={handleMouseLeave}
      >
        {loading || !selectedMedia ? (
          <Skeleton width="100%" height="500" borderRadius={8} />
        ) : selectedMedia === "video" ? (
          selectedColor?.video_source?.includes("youtube") ? (
            <iframe
              src={`${selectedColor.video_source}?autoplay=1&mute=1`}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          ) : (
            <video
              controls
              autoPlay
              muted
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            >
              <source src={selectedColor.video_source} type="video/mp4" />
            </video>
          )
        ) : (
          <img
            src={selectedMedia}
            ref={imageRef}
            alt="Product"
            className="main-image zoom-image"
            style={{
              ...zoomStyle,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              mixBlendMode: "darken",
              border: "1px solid #eeeded"
            }}
          />
        )}
      </div>
    </div>
  );
};

export default ProductQuickViewGallery;